import { Button, MultiSelectDropDown, SelectDropDown } from '@wot/components';
import { IGrades, ILevels, IProfessionHobby, IProfessionSkill, IProfessionSubject, ITutor } from '@wot/typings';
import { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import categoryApi from '../../api/categories';
import tutorsApi from '../../api/tutors';
import { ARROW_DOWN_BLACK, BACK_ARROW } from '../../assets/icons';
import { CAUTION } from '../../assets/images';
import BreadCrumb from '../../components/BreadCrumb';
import TutorCard from '../../components/TutorCard';
import { useClickOutside } from '../../hooks';
import { LOADING } from '../../assets/animated';
import Footer from '../../components/Landing/Footer';
import { SEO } from '../../components/SEO';
import { BreadcrumbSchema } from '../../components/StructuredData';

const gradeOptions: IGrades[] = [
  'Grade I',
  'Grade II',
  'Grade III',
  'Grade IV',
  'Grade V',
  'Grade VI',
  'Grade VII',
  'Grade VIII',
  'Grade IX',
  'Grade X',
  'Grade XI',
  'Grade XII',
  'College Level'
];
const boardOptions = ['ICSE', 'CBSE', 'State'];

const levelOptions: ILevels[] = ['beginner', 'intermediate', 'advance'];

const qualityOptions = ['standard', 'premium'];

export default function FindTutor() {
  const [loading, setLoading] = useState(false);
  const [tutorsList, setTutorsList] = useState<ITutor[]>([]);

  const [hobbyOptions, setHobbyOptions] = useState<{ type: string; category: IProfessionHobby }[]>([]);
  const [skillOptions, setSkillOptions] = useState<{ type: string; category: IProfessionSkill }[]>([]);
  const [subjectOptions, setSubjectOptions] = useState<{ type: string; category: IProfessionSubject }[]>([]);

  const [typeOptions, setTypeOptions] = useState<string[]>([]);
  const [total, setTotal] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [resultsPerPage /* , setResultsPerPage */] = useState<number>(8);

  const [subList, setSubList] = useState<any[]>([]);
  const [gradeList, setGradeList] = useState<any[]>([]);
  const [boardList, setBoardList] = useState<any[]>([]);

  const [hobbyList, setHobbyList] = useState<any[]>([]);
  const [typeList, setTypeList] = useState<any[]>([]);

  const [levelList, setLevelList] = useState<any[]>([]);
  const [quality, setQuality] = useState('');

  const [skillList, setSkillList] = useState<any[]>([]);

  const [filterSortOpt, setFilterSortOpt] = useState(false); // Hide/Show
  // const [sort, setSort] = useState<"Newly Joined" | "Rating Highest">();
  const [categorySelected, setCategorySelected] = useState<'hobby' | 'subject' | 'skill' | ''>('');
  const navigate = useNavigate();
  const filterSortRef = useRef(null);
  useClickOutside(filterSortRef, () => setFilterSortOpt(false));
  const location = useLocation();

  useEffect(() => {
    if (location.state) {
      setCategorySelected(location.state.categoryType);
      if (location.state.categoryType === 'subject') {
        setSubList([location.state.name]);
      }
      if (location.state.categoryType === 'hobby') {
        setHobbyList([location.state.name]);
      }
      if (location.state.categoryType === 'skill') {
        setSkillList([location.state.name]);
      }
      let filter = Object.assign(
        {},
        { page: currentPage },
        { resultsPerPage },
        location.state.categoryType && { category: location.state.categoryType },
        location.state.name && { categoryName: [location.state.name] }
      );
      setLoading(true);
      tutorsApi
        .getFilteredTutors(filter)
        .then((data) => {
          setTutorsList(data.results.filter((s: any) => s.status === "active"));
          setTotal(data.count);
          setLoading(false);
        })
        .catch(() => setLoading(false));
    } else {
      getFilteredTutors(currentPage);
    }
  }, [location.state]);

  const getFilteredTutors = (currentPage: number) => {
    let filter = Object.assign(
      {},
      { page: currentPage },
      { resultsPerPage },
      categorySelected && { category: categorySelected },
      subList.length > 0 && { categoryName: subList },
      hobbyList.length > 0 && { categoryName: hobbyList },
      skillList.length > 0 && { categoryName: skillList },
      gradeList.length > 0 && { grades: gradeList },
      boardList.length > 0 && { boards: boardList },
      typeList.length > 0 && { categoryTypeName: typeList },
      levelList.length > 0 && { levels: levelList },
      quality && { quality }
    );
    setLoading(true);
    tutorsApi
      .getFilteredTutors(filter)
      .then((data) => {
        setTutorsList(data.results.filter((s: any) => s.status === "active"));
        setTotal(data.count);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => {
    clearAllFilters();
    if (categorySelected === 'hobby') {
      categoryApi.getCategoriesByType('hobby').then((data) => {
        setHobbyOptions(data);
        //Types logic must be fixed
        let types: string[] = [];
        data.map((hobby: any) => {
          hobby.category.types.map((type: any) => {
            types.push(type.name);
          });
        });
        setTypeOptions(types);
      });
    } else if (categorySelected === 'subject') {
      categoryApi.getCategoriesByType('subject').then((data) => {
        setSubjectOptions(data);
      });
    } else if (categorySelected === 'skill') {
      categoryApi.getCategoriesByType('skill').then((data) => {
        setSkillOptions(data);

        //Types logic must be fixed
        let types: string[] = [];
        data.map((skill: any) => {
          skill.category.types.map((type: any) => {
            types.push(type.name);
          });
        });
        setTypeOptions(types);
      });
    }
  }, [categorySelected]);

  const clearAllFilters = () => {
    setHobbyList([]);
    setSkillList([]);
    setTypeList([]);
    setSubList([]);
    setLevelList([]);
    setGradeList([]);
    setBoardList([]);
    setQuality('');
  };

  useEffect(() => {
    setTypeList([]);
    if (hobbyList.length > 0) {
      let types: any[] = [];
      hobbyOptions.forEach((hobby) => {
        if (hobbyList.includes(hobby.category.name)) {
          if (hobby.category.types) {
            types.push(hobby.category.types.map((item) => item.name));
          }
        }
      });
      setTypeOptions(types.flat());
    }
  }, [hobbyList]);

  useEffect(() => {
    setTypeList([]);
    if (skillList.length > 0) {
      let types: any[] = [];
      skillOptions.forEach((skill) => {
        if (skillList.includes(skill.category.name)) {
          if (skill.category.types) {
            types.push(skill.category.types.map((item) => item.name));
          }
        }
      });
      setTypeOptions(types.flat());
    }
  }, [skillList]);

  function FilterSortMenu() {
    return (
      <div
        ref={filterSortRef}
        className="md:min-w-[500px] min-w-full flex flex-col border border-neutralBlue1 absolute top-20 md:left-5 left-0 p-6 bg-white drop-shadow-lg rounded-lg"
      >
        {/* Sort options */}
        {/* <div className="flex flex-col gap-2 pb-7 border-b-2 border-neutralGray3">
          <p className="text-sm font-medium">Sort By</p>
          <div className="flex flex-row gap-4">
            <div
              className={`${
                sort === "Newly Joined" ? "bg-neutralBlue2" : "bg-white"
              } border-2 border-neutralBlue1 basis-[30%] text-center px-2 py-3 text-sm font-medium cursor-pointer rounded-lg`}
              onClick={() => setSort("Newly Joined")}
            >
              Newly Joined
            </div>
            <div
              className={`${
                sort === "Rating Highest" ? "bg-neutralBlue2" : "bg-white"
              } border-2 border-neutralBlue1 basis-[30%] text-center px-2 py-3 text-sm font-medium cursor-pointer rounded-lg`}
              onClick={() => setSort("Rating Highest")}
            >
              Rating Highest
            </div>
          </div>
        </div> */}
        <div className="flex flex-col gap-2 pt-4 bg-white z-10" >
          <div className="flex flex-row gap-3">
            <p className="text-sm font-medium">Filter By Category</p>
            <div
              className="border-2 border-neutralGray3 px-2 text-center text-xs font-normal cursor-pointer rounded-3xl"
              onClick={() => setCategorySelected('')}
            >
              Clear
            </div>
          </div>
          <div className="flex sm:flex-row flex-col gap-4 sm:gap-0 justify-between">
            <div
              className={`${categorySelected === 'subject' ? 'bg-neutralBlue2' : 'bg-white'
                } border border-neutralBlue1 basis-[32%] text-center px-2 py-3 text-sm font-medium cursor-pointer rounded-lg`}
              onClick={() => setCategorySelected('subject')}
            >
              Subject
            </div>
            <div
              className={`${categorySelected === 'hobby' ? 'bg-neutralBlue2' : 'bg-white'
                } border border-neutralBlue1 basis-[32%] text-center px-2 py-3 text-sm font-medium cursor-pointer rounded-lg`}
              onClick={() => setCategorySelected('hobby')}
            >
              Hobby
            </div>
            <div
              className={`${categorySelected === 'skill' ? 'bg-neutralBlue2' : 'bg-white'
                } border border-neutralBlue1 basis-[32%] text-center px-2 py-3 text-sm font-medium cursor-pointer rounded-lg`}
              onClick={() => setCategorySelected('skill')}
            >
              skill development
            </div>
          </div>
        </div>
        {/* subject*/}
        {categorySelected === 'subject' && (
          <>
            <div className="flex flex-col gap-2 pt-3">
              <div className="flex flex-row gap-3">
                <p className="text-sm font-medium">Filter By Subject Name</p>
                <div
                  className="border-2 border-neutralGray3 px-2 text-center text-xs font-normal cursor-pointer rounded-3xl"
                  onClick={() => {
                    setSubList([]);
                  }}
                >
                  Clear
                </div>
              </div>
              <div>
                <MultiSelectDropDown
                  placeholder="Search by Subject"
                  onChange={(values) => setSubList(values)}
                  options={subjectOptions.map((subject) => subject.category.name)}
                  values={subList}
                  selectAll
                />
              </div>
            </div>
            <div className="flex flex-col gap-2 pt-3">
              <div className="flex flex-row gap-3">
                <p className="text-sm font-medium">Filter By Grade</p>
                <div
                  className="border-2 border-neutralGray3 px-2 text-center text-xs font-normal cursor-pointer rounded-3xl"
                  onClick={() => {
                    setGradeList([]);
                  }}
                >
                  Clear
                </div>
              </div>
              <MultiSelectDropDown
                placeholder="Search by Grade I, Grade II, etc."
                onChange={(values) => setGradeList(values)}
                options={gradeOptions}
                values={gradeList}
                selectAll
              />
            </div>
            <div className="flex flex-col gap-2 pt-3">
              <div className="flex flex-row gap-3">
                <p className="text-sm font-medium">Filter By Board</p>
                <div
                  className="border-2 border-neutralGray3 px-2 text-center text-xs font-normal cursor-pointer rounded-3xl"
                  onClick={() => {
                    setBoardList([]);
                  }}
                >
                  Clear
                </div>
              </div>
              <MultiSelectDropDown
                placeholder="Search by ICSE, CBSE, etc."
                onChange={(values) => setBoardList(values)}
                options={boardOptions}
                values={boardList}
                selectAll
              />
            </div>
          </>
        )}
        {/* hobby*/}
        {categorySelected === 'hobby' && (
          <>
            <div className="flex flex-col gap-2 pt-3">
              <div className="flex flex-row gap-3">
                <p className="text-sm font-medium">Filter By Hobby Name</p>
                <div
                  className="border-2 border-neutralGray3 px-2 text-center text-xs font-normal cursor-pointer rounded-3xl"
                  onClick={() => setHobbyList([])}
                >
                  Clear
                </div>
              </div>
              <MultiSelectDropDown
                placeholder="Search by Hobby"
                onChange={(values) => setHobbyList(values)}
                options={hobbyOptions.map((hobby) => hobby.category.name)}
                values={hobbyList}
                selectAll
              />
            </div>
            <div className="flex flex-col gap-2 pt-3">
              <div className="flex flex-row gap-3">
                <p className="text-sm font-medium">Filter By Hobby Type</p>
                <div
                  className="border-2 border-neutralGray3 px-2 text-center text-xs font-normal cursor-pointer rounded-3xl"
                  onClick={() => {
                    setTypeList([]);
                  }}
                >
                  Clear
                </div>
              </div>
              <MultiSelectDropDown
                placeholder="Search by Electric, Classic, etc."
                onChange={(values) => setTypeList(values)}
                options={typeOptions}
                values={typeList}
                selectAll
              />
            </div>
            <div className="flex flex-col gap-2 pt-3">
              <div className="flex flex-row gap-3">
                <p className="text-sm font-medium">Filter By Level</p>
                <div
                  className="border-2 border-neutralGray3 px-2 text-center text-xs font-normal cursor-pointer rounded-3xl"
                  onClick={() => setLevelList([])}
                >
                  Clear
                </div>
              </div>
              <MultiSelectDropDown
                placeholder="Are you a beginner, Inter, Advanced ..."
                onChange={(values) => setLevelList(values)}
                options={levelOptions}
                values={levelList}
                selectAll
              />
            </div>
          </>
        )}
        {/* skill development*/}
        {categorySelected === 'skill' && (
          <>
            <div className="flex flex-col gap-2 pt-3">
              <div className="flex flex-row gap-3">
                <p className="text-sm font-medium">Filter By Skill Name</p>
                <div
                  className="border-2 border-neutralGray3 px-2 text-center text-xs font-normal cursor-pointer rounded-3xl"
                  onClick={() => setSkillList([])}
                >
                  Clear
                </div>
              </div>
              <MultiSelectDropDown
                placeholder="Search by Skill Development"
                onChange={(values) => setSkillList(values)}
                options={skillOptions.map((skill) => skill.category.name)}
                values={skillList}
                selectAll
              />
            </div>
            <div className="flex flex-col gap-2 pt-3">
              <div className="flex flex-row gap-3">
                <p className="text-sm font-medium">Filter By Skill Type</p>
                <div
                  className="border-2 border-neutralGray3 px-2 text-center text-xs font-normal cursor-pointer rounded-3xl"
                  onClick={() => setTypeList([])}
                >
                  Clear
                </div>
              </div>
              <MultiSelectDropDown
                placeholder="Search by Programming, Painting, etc."
                onChange={(values) => setTypeList(values)}
                options={typeOptions}
                values={typeList}
                selectAll
              />
            </div>
            <div className="flex flex-col gap-2 pt-3">
              <div className="flex flex-row gap-3">
                <p className="text-sm font-medium">Filter By Level</p>
                <div
                  className="border-2 border-neutralGray3 px-2 text-center text-xs font-normal cursor-pointer rounded-3xl"
                  onClick={() => setLevelList([])}
                >
                  Clear
                </div>
              </div>
              <MultiSelectDropDown
                placeholder="Are you a beginner, Inter, Advanced ..."
                onChange={(values) => setLevelList(values)}
                options={levelOptions}
                values={levelList}
                selectAll
              />
            </div>
          </>
        )}
        <div className="flex flex-col gap-2 pt-3">
          <div className="flex flex-row gap-3">
            <p className="text-sm font-medium">Filter By Quality</p>
            <div
              className="border-2 border-neutralGray3 px-2 text-center text-xs font-normal cursor-pointer rounded-3xl"
              onClick={() => {
                setQuality('');
              }}
            >
              Clear
            </div>
          </div>
          <SelectDropDown
            placeholder="Search by Standard, Premium, etc."
            onChange={(value) => setQuality(value)}
            options={qualityOptions}
            value={quality}
          />
        </div>
        <div className="flex mt-5 gap-7">
          <Button
            text="Clear All"
            block
            type="s-outlined"
            onClick={() => {
              setCategorySelected('');
              clearAllFilters();
            }}
          />
          <Button
            text="Apply"
            block
            type="primary"
            onClick={() => {
              getFilteredTutors(currentPage);
              setFilterSortOpt(false);
            }}
          />
        </div>
      </div>
    );
  }
  return (
    <>
    <SEO 
      title="Find Online Tutors - Search & Filter Expert Tutors"
      description="Search and filter through our expert tutors to find the perfect match for your learning needs. Filter by subject, grade, board, and more."
      keywords="find tutor, search tutor, online tutor, expert tutor, mathematics tutor, science tutor, language tutor, filtered search"
      url="/find-tutor"
      type="website"
      og={{
        type: 'website',
        siteName: 'WorldoTutor',
        locale: 'en_US',
        image: {
          url: '/imgi_1_favicon.png',
          alt: 'Find Online Tutors - WorldoTutor',
          width: 1200,
          height: 630
        }
      }}
      twitter={{
        card: 'summary_large_image',
        site: '@worldotutor',
        image: {
          url: '/imgi_1_favicon.png',
          alt: 'Find Online Tutors - WorldoTutor'
        }
      }}
    />
    
    {/* Structured Data for Breadcrumbs */}
    <BreadcrumbSchema 
      items={[
        { name: 'Home', url: '/' },
        { name: 'Find Tutor', url: '/find-tutor' }
      ]}
    />
    
    <div className="w-full bg-white">
      <div className="container">
        <div className="hidden md:flex gap-3 py-5">
          <div
            className="w-8 h-8 flex items-center justify-center  rounded-full cursor-pointer drop-shadow-md"
            onClick={() => navigate(-1)}
          >
            <img src={BACK_ARROW} alt="Go Back" />
          </div>
          <BreadCrumb />
        </div>
        <div className="md:bg-whit flex flex-col gap-4 p-5 rounded">
          <h2 className="text-5xl font-semibold">Find a Tutor</h2>
        </div>
        <div className="bg-neutralGray flex flex-col md:flex-row items-center justify-between p-4 relative z-30 rounded-lg bg-gray-200 border-2">
          <div className="flex items-center gap-3 ">
            <button
              className="flex items-center gap-2 text-base font-semibold px-3 py-2 bg-white rounded-lg hover:shadow-md transition-colors"
              onClick={() => setFilterSortOpt(!filterSortOpt)}
              aria-expanded={filterSortOpt}
            >
              <img
          src={ARROW_DOWN_BLACK}
          alt="Filter"
          className={`w-4 h-4 transition-transform ${filterSortOpt ? 'rotate-180' : ''}`}
              />
              <span>Filter & Sort</span>
              {[
          subList.length,
          hobbyList.length,
          skillList.length,
          gradeList.length,
          boardList.length,
          typeList.length,
          levelList.length,
          quality ? 1 : 0
              ].reduce((a, b) => a + b, 0) > 0 && (
          <span className="ml-2 inline-flex items-center justify-center bg-primary text-white text-xs font-medium rounded-full h-5 w-5">
            {
              [
                subList.length,
                hobbyList.length,
                skillList.length,
                gradeList.length,
                boardList.length,
                typeList.length,
                levelList.length,
                quality ? 1 : 0
              ].reduce((a, b) => a + b, 0)
            }
          </span>
              )}
            </button>
            <div className="hidden md:block text-sm text-gray-600">
              Refine results by category, grade, level & quality
            </div>
          </div>

          <div className="flex items-center gap-3 mt-3 md:mt-0">
            <button
              className="text-sm text-black px-3 py-2 rounded hover:bg-black hover:text-white transition-colors"
              onClick={() => {
          clearAllFilters();
          getFilteredTutors(1);
              }}
            >
              Clear All
            </button>

            <div className="w-40 border-black">
              <SelectDropDown              
          placeholder="Sort by"
          options={['Relevance', 'Newest', 'Top Rated']}
          value={''}
          onChange={() => {
            /* optionally hook up sort behavior */
          }}
              />
            </div>
          </div>

          {filterSortOpt && <FilterSortMenu />}
        </div>
        {loading ? (
          <div className="min-h-[512px] flex items-center justify-center">
            <img src={LOADING} className="w-14 h-14" />
          </div>
        ) : (
          <div className="bg-whit flex flex-col p-3 gap-2">
            {tutorsList.length > 0 ? (
              <div className="flex flex-col">
                <div className="grid 2xl:grid-cols-4 xl:grid-cols-4 sm:grid-cols-2 grid-cols-1 gap-5">
                  {tutorsList.map((item: any, index: any) => (
                    <TutorCard item={item} key={index} />
                  ))}
                </div>
                <div className="flex w-full items-center justify-between py-2 px-3 bg-whit">
                  <div className="flex items-center gap-4">
                    <p className="text-sm font-semibold text-ellipsis text-left text-gray-900">
                      {`${currentPage} of ${Math.ceil(total / resultsPerPage)} pages`}
                    </p>
                    <button
                      onClick={() => {
                        setCurrentPage(currentPage - 1);
                        getFilteredTutors(currentPage - 1);
                      }}
                      disabled={currentPage === 1}
                      className={`border-2 rounded-sm ${currentPage === 1 ? 'opacity-40' : 'opacity-100'
                        } font-semibold p-2 text-xs flex items-center justify-center`}
                    >
                      Prev
                    </button>
                    <button
                      onClick={() => {
                        setCurrentPage(currentPage + 1);
                        getFilteredTutors(currentPage + 1);
                      }}
                      disabled={currentPage >= Math.ceil(total / resultsPerPage)}
                      className={`border-2 rounded-sm ${currentPage >= Math.ceil(total / resultsPerPage) ? 'opacity-40' : 'opacity-100'
                        } font-semibold  p-2 text-xs flex items-center justify-center`}
                    >
                      Next
                    </button>
                  </div>
                  <p className="text-sm font-semibold">{total} Results found.</p>
                </div>
              </div>
            ) : (
              <>
                <div className="flex flex-col gap-5 items-center py-10">
                  <img src={CAUTION} alt="No results found" className="rounded-full" />
                  <div className="flex flex-col items-center w-full gap-2">
                    <span className="text-2xl font-medium">Oops,</span>
                    <span className="w-full text-lg font-normal text-center">No trainers found.</span>
                  </div>
                  <div className="max-w-[200px]">
                    <Link to="/post-requirement">
                      <Button text="Post a Requirement" size="lg" />
                    </Link>
                  </div>
                </div>
              </>
            )}
          </div>
        )}
      </div>
      <div className="bg-primary flex flex-col items-center py-4 mt-10 gap-3">
        <span className="text-white text-base font-medium text-center">
          Do you need help in finding the best teacher matching your requirements?
        </span>
        <div>
          <Link to="/post-requirement">
            <Button text="Post Your Requirement" onClick={() => { }} />
          </Link>
        </div>
      </div>
     <div className='bg-neutralBlack'>
     <Footer/>
     </div>
    </div>
    </>
  );
}
